import React from 'react';

import i18n from '@/settings/i18n';
import * as styles from './index.module.scss';

export const PreviewDivider: React.FC = () => (
  <div className={styles.divider}>{i18n.t('text.user.index.preview')}</div>
);
